var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{attrs:{"uk-tooltip":'title:' + _vm.tooltip ? _vm.tooltip : ''}},[(_vm.text)?_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))]):_vm._e(),_c('div',{class:'round-button uk-icon-button' +
            (_vm.isDark ? ' dark' : '') +
            (_vm.isDisabled ? ' uk-button-disabled cursor-notallowed' : ''),on:{"click":_vm.callAction}},[(_vm.isLoading)?_c('div',{attrs:{"uk-spinner":""}}):_c('Icon',{attrs:{"icon":_vm.icon,"ratio":_vm.ratio}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }